export default function News() {
  const newsItems = [
    {
      date: '2024.03.15',
      category: 'イベント',
      title: '3月のビーチクリーン＆朝食会開催のお知らせ',
      description: '毎月第3日曜日恒例のビーチクリーン活動を開催します。参加者には特製朝食をご用意！',
      image: 'https://public.readdy.ai/ai/img_res/6d0dd77fbce20a4e5c636aae80050d8b.jpg'
    },
    {
      date: '2024.03.01',
      category: '新メニュー',
      title: '春限定メニュー「桜スムージー」登場',
      description: 'いちごと桜の花びらを使った、春らしいピンク色のスムージーが新登場。期間限定でお楽しみいただけます。',
      image: 'https://readdy.ai/api/search-image?query=Pink%20cherry%20blossom%20smoothie%20in%20tall%20glass%2C%20strawberries%20and%20sakura%20petals%2C%20spring%20seasonal%20drink%2C%20beautiful%20presentation%2C%20professional%20food%20photography%2C%20soft%20natural%20lighting%2C%20simple%20clean%20background%2C%20elegant%20and%20fresh&width=800&height=500&seq=news-smoothie-001&orientation=landscape'
    },
    {
      date: '2024.02.20',
      category: 'お知らせ',
      title: 'Instagramフォロワー1万人突破記念キャンペーン',
      description: 'おかげさまでInstagramフォロワーが1万人を突破しました！感謝を込めて、ドリンク1杯無料クーポンをプレゼント中。',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20celebration%20concept%2C%20Instagram%20milestone%20achievement%2C%20coffee%20and%20smartphone%20on%20wooden%20table%2C%20beachside%20cafe%20atmosphere%2C%20professional%20lifestyle%20photography%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background&width=800&height=500&seq=news-instagram-001&orientation=landscape'
    }
  ];

  return (
    <section id="news" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            NEWS &amp; EVENT
          </h3>
          <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {newsItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all transform hover:-translate-y-2 cursor-pointer"
            >
              <div 
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `url(${item.image})` }}
              ></div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm text-gray-500">{item.date}</span>
                  <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3">
                  {item.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Beach Clean Event Highlight */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-400 rounded-2xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="p-8 md:p-12 text-white flex flex-col justify-center">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-calendar-event-line text-2xl"></i>
                </div>
                <h4 className="text-3xl font-bold">定期イベント</h4>
              </div>
              <h5 className="text-2xl font-bold mb-4">
                ビーチクリーン＆朝食会
              </h5>
              <p className="text-lg mb-4 opacity-90">
                毎月第3日曜日 8:00スタート
              </p>
              <p className="mb-6 leading-relaxed opacity-90">
                美しい海を守るため、みんなで楽しくビーチクリーン活動を行います。活動後は、特製の朝食をご用意。海を愛する仲間たちと素敵な朝を過ごしませんか？
              </p>
              <div className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                <span>参加費無料・予約不要</span>
              </div>
            </div>
            <div 
              className="h-64 md:h-auto bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://readdy.ai/api/search-image?query=Group%20of%20happy%20volunteers%20cleaning%20beach%20together%2C%20sunrise%20morning%20light%2C%20people%20holding%20trash%20bags%2C%20teamwork%20and%20community%20spirit%2C%20ocean%20and%20sand%2C%20positive%20environmental%20action%2C%20professional%20photography%2C%20inspiring%20atmosphere&width=800&height=600&seq=event-highlight-001&orientation=landscape)'
              }}
            ></div>
          </div>
        </div>

        {/* Instagram Section */}
        <div className="mt-12 text-center">
          <h4 className="text-2xl font-bold text-gray-900 mb-4">
            最新情報はInstagramで
          </h4>
          <p className="text-gray-600 mb-6">
            日々の様子や限定メニュー、イベント情報をお届けしています
          </p>
          <a
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-lg transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-instagram-line text-2xl mr-3"></i>
            Instagramをフォロー
          </a>
        </div>
      </div>
    </section>
  );
}